import React, { useState, useImperativeHandle } from "react";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/core/styles/index";
import {
  IconButton,
  TextField,
  InputAdornment,
  Paper,
  Fab,
  Popover,
} from '@material-ui/core';
import FilterLabelIcon from "../Icon/FilterLabelIcon";

const styleInputSearch = () => ({
  root: {
    width: '100%',
    maxWidth: '436px',
    borderRadius: "8px !important",
    background: "#F2F2F2",
    justifyContent: 'center',
    fontWeight: 400,
    height: "38px !important",
    color: "#868686",
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  inputRoot: {
    color: "#868686",
    padding: "0 10px",
    fontWeight: 400,
    fontSize: '12px',
  },
  input: {
    padding: '5px 0 3px 0',
    fontFamily: 'Poppins',
    fontSize: '14px',
  },
  inputFocused: {
    borderColor: "#555"
  },
  paper: {
    padding: "24px",
    backgroundColor: "#FFF",
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.2)",
    borderRadius: "20px",
    position: 'absolute',
    left: '255px',
    top: '80px',
    "& h1": {
      fontSize: "24px",
      fontWeight: 600,
    }
  },
  popper: {
    background: 'transparent',
    zIndex: 1000,
    boxShadow: 'none',
    border: 'none'
  },
  iconButtonSearch: {
    width: 30,
    height: 30,
    padding: 0,
  },
  Fab: {
    minHeight: 26,
    height: 32,
    width: 32,
    boxShadow: 'none',
  },
  contentDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconFilter: {
    "&:hover": {
      cursor: 'pointer',
    }
  },
});

const InputSearchFilterCustom = (props) => {
  const {
    classes,
    classInputRoot,
    classInput,
    startAdornment,
    endAdornment,
    hideStartAdornment,
    hideEndAdornment,
    search,
    clearSearch,
    value,
    showIconClose,
    disabledButton,
    hiddenFilter,
    children,
    popoverWidth,
    popoverHeight,
    title = "Filtros",
    forwardedRef,
    ...rest
  } = props;

  const [openModalFiltrar, setOpenModalFiltrar] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [placement, setPlacement] = useState(null);

  const getStartAdornment = startAdornment || (
    <InputAdornment position="start">
      <IconButton className={classes.iconButtonSearch} onClick={() => search && search()}>
        <SearchIcon className={classes.icon} />
      </IconButton>
    </InputAdornment>
  );

  const onClickOpenModalFiltrar = newPlacement => event => {
    setAnchorEl(event.currentTarget);
    setOpenModalFiltrar((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const onClickCloseModalFiltrar = () => {
    setOpenModalFiltrar(false);
  };

  useImperativeHandle(forwardedRef, () => ({
    closePopover: () => {
      setOpenModalFiltrar(false);
    },
  }));

  const getEndAdornment = () => {
    return (
      endAdornment || (
        <InputAdornment position="start">
          {(value || showIconClose) && (
            <IconButton
              className={classes.iconButtonSearch}
              onClick={() => clearSearch && clearSearch()}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
          )}
          {!hiddenFilter && (
            <FilterLabelIcon
              className={classes.iconFilter}
              onClick={!!!openModalFiltrar ? onClickOpenModalFiltrar("bottom-end") : onClickCloseModalFiltrar}
              disabled={disabledButton}
            />
          )}
        </InputAdornment>
      )
    );
  };

  return (
    <div className={classes.content}>
      <TextField
        className={classes.root}
        id="input-with-icon-textfield"
        InputProps={{
          disableUnderline: true,
          classes: {
            root: `${classes.inputRoot} ${classInputRoot}`,
            input: `${classes.input} ${classInput}`,
            focused: classes.inputFocused,
          },
          startAdornment: hideStartAdornment ? null : getStartAdornment,
          endAdornment: hideEndAdornment ? null : getEndAdornment(),
        }}
        InputLabelProps={{
          shrink: true,
        }}
        value={value}
        {...rest}
      />
      <Popover
        className={classes.popper}
        open={openModalFiltrar}
        anchorEl={anchorEl}
        placement={placement}
        onClose={onClickCloseModalFiltrar}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'left',
          horizontal: 'left',
        }}
        PaperProps={{
          className: classes.popper,
        }}
      >
        <Paper className={classes.paper} style={popoverWidth || popoverHeight ? { width: popoverWidth, height: popoverHeight } : {}}>
          <div className={classes.contentDiv}>
            <h1 className={classes.filtro}>{title}</h1>
            <Fab size="small" className={classes.Fab} onClick={onClickCloseModalFiltrar}>
              <CloseIcon fontSize={'small'} />
            </Fab>
          </div>
          {children}
        </Paper>
      </Popover>
    </div>
  );
};

const InputSearchFilterCustomWithStyles = withStyles(styleInputSearch)(InputSearchFilterCustom);

export default React.forwardRef((props, ref) => (
  <InputSearchFilterCustomWithStyles {...props} forwardedRef={ref} />
));